import { API } from '../../api';
import { Button, Card, Col, Input, PageHeader, Row, Space, Table, Tooltip, message } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import CreateDataContractModal from './createDataContractsModal';
import React, { useEffect, useState } from 'react';

const { TextArea } = Input;

message.config({
  duration: 3,
  maxCount: 3,
  rtl: false,
});

const DataContracts = () => {
  const [dataContract, setDataContract] = useState('{}');
  const [showCreateContractModal, toggleCreateContractModal] = useState(false);
  const [dataContracts, setDataContractList] = useState(null);
  const [searchText, setSearchText] = useState('');

  const fetchDataContracts = async () => {
    try {
      const { data } = await API.get('/dataContract');
      setDataContractList(data);
    } catch (error) {
      message.error('There Was A Problem Fetching The Data Contracts');
      setDataContractList([]);
    }
  };

  const handleViewContractClick = contractId => {
    const contractToDisplay = dataContracts.find(({ id }) => id === contractId);
    setDataContract(contractToDisplay);
  };

  const columnSort = (a, b) => {
    if (!!a.name && !!b.name) {
      return a.name.localeCompare(b.name);
    }

    return null;
  };

  useEffect(() => {
    fetchDataContracts();
  }, []);

  const dataContractsDisplayed =
    dataContracts !== null
      ? dataContracts.filter(({ name }) => {
          return name.toLowerCase().includes(searchText.toLowerCase());
        })
      : [];

  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => window.history.back()}
        title="Data Contracts"
      />
      <Row>
        <Col span={10}>
          <p>Here you can create and view data contracts.</p>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col style={{ marginBottom: 5 }}>
          <Button
            style={{ marginRight: '2px' }}
            type="primary"
            onClick={() => toggleCreateContractModal(true)}
          >
            Create New Contract
          </Button>
          <Input
            data-cy="search-clients-input"
            style={{ width: '350px' }}
            addonBefore="Search:"
            onChange={e => setSearchText(e.target.value)}
          />
        </Col>
      </Row>
      <Row justify="start" align="top" gutter={[20, 16]}>
        <Col span={12}>
          <Card title="Existing Contracts">
            <Table
              columns={[
                {
                  title: 'Name',
                  dataIndex: 'name',
                  defaultSortOrder: 'ascend',
                  sorter: columnSort,
                },
                {
                  title: 'Version',
                  dataIndex: 'version',
                  sorter: columnSort,
                },
                {
                  title: 'Description',
                  dataIndex: 'description',
                  sorter: columnSort,
                },
                {
                  title: '',
                  width: 100,
                  render: (_value, { id, name }) => {
                    return (
                      <Space size="middle">
                        <Button
                          data-cy={name}
                          style={{ marginRight: '2px' }}
                          type="primary"
                          onClick={() => handleViewContractClick(id)}
                        >
                          View
                        </Button>
                      </Space>
                    );
                  },
                },
              ]}
              rowKey="id"
              className="dataContract-table"
              pagination={{ pageSize: 8, size: 'small' }}
              size="medium"
              loading={false}
              dataSource={dataContractsDisplayed}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card
            title={
              <>
                Contract Contents
                <Tooltip placement="right" title="The contract must be formatted as JSON">
                  &nbsp; <QuestionCircleOutlined />
                </Tooltip>
              </>
            }
          >
            <TextArea
              disabled
              rows={25}
              bordered={false}
              showCount
              value={JSON.stringify(dataContract, null, 4)}
              maxLength={50000}
            />
          </Card>
        </Col>
      </Row>
      <CreateDataContractModal
        isOpen={showCreateContractModal}
        closeModal={() => {
          toggleCreateContractModal(false);
        }}
        refreshDataContracts={fetchDataContracts}
      />
    </>
  );
};

export default DataContracts;
